export default __webpack_public_path__ + "static/media/hug.155698e3.png";